import classNames from 'classnames';

import { icons, IconText } from '../../generic/Icon';
import SummaryStatPanel from '../generic/SummaryStatPanel';
import type { ProjectDashboardRevision } from '../projectDashboardTypes';

type SummaryDependencyLinkProps = {
  revision: ProjectDashboardRevision;
  baseUrl: string;
  isScannedForIssues: boolean;
  onShowNoDependenciesModal(): void;
};

const SummaryDependencyLink = ({
  revision,
  baseUrl,
  isScannedForIssues,
  onShowNoDependenciesModal,
}: SummaryDependencyLinkProps) => {
  const revisionIsUnsupported = revision.data.unsupported;
  const depCacheValid: boolean = revision.dependency_cache_updated && (
    new Date(revision.dependency_cache_updated) >= new Date(revision.dependency_cache_valid)
  );

  if (revision.data.dependency_count === null || revision.data.dependency_count > 0 || !revision.data.isSteady) {
    // Assign icon and count according to revision state.
    const icon = revisionIsUnsupported ? icons.warning : icons.relationship;

    const depCount = (revision.data.isSteady || isScannedForIssues) ? revision.data.dependency_count : '...';

    const panelClassName = classNames('panel', 'panel-stat', 'project-summary-panel-stat', {
      'panel-success': depCacheValid,
    });

    return (
      <SummaryStatPanel
        to={`${baseUrl}/browse/dependencies`}
        count={depCount}
        label="Dependencies"
        icon={icon}
        isLoading={!(revision.data.isSteady || isScannedForIssues)}
        className={panelClassName}
      />
    );
  }

  // If no dependencies are found, show an alert state.
  return (
    <a
      className="card card-error clickable"
      onClick={onShowNoDependenciesModal}
      role="button">
      <b><IconText icon={icons.warning} text="No Dependencies Found" marginAmount="0.7em" /></b>
    </a>
  );
};

export default SummaryDependencyLink;
